export default __webpack_public_path__ + "media/images/features/saga/saga_castle-e52009636396e72738717bb9e6432f88.jpg";